module.exports = __webpack_public_path__ + "web/img/ques_bg_rb.fbcd7a24.png";